import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';

import { STORAGE_KEYS } from '../constants/storage-keys';
import { AuthService } from '../services/auth.service';
import { ToastService } from '../services/toast.service';

/**
 * Guard for Donation Portal routes.
 * Unauthenticated users are always redirected to Company SSO.
 * Non-internal users are denied access and redirected to login.
 */
export const authGuard: CanActivateFn = (_route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const authService = inject(AuthService);
  const toast = inject(ToastService);

  if (!authService.isAuthenticated()) {
    sessionStorage.setItem(STORAGE_KEYS.DONATION_RETURN_URL, state.url.split('?')[0]);
    authService.redirectToLogin();
    return false;
  }

  const userInfo = authService.getUserInfo();
  if (!userInfo?.userOrigin || userInfo.userOrigin !== 'Internal') {
    toast.error('Access Denied', 'You do not have permission to access the Donation Portal.');
    authService.redirectToLogin();
    return false;
  }

  return true;
};
